import React from 'react';

// project-imports
import { TestimonialFourParams } from '../../utils/script';
import { useTestimonialContext } from '../../context/testimonial_context';
import Spinner from '../spinner-component/SpinnerOne';
import ErrorComponent from '../error-message/ErrorComponent';
import { _setBgColor, truncateText } from '../../utils';
import ToolTip from '../../common/Tooltip/ToolTip';

// third party
import Slider from 'react-slick';
import Avatar from 'react-avatar';

const TestimonialFour = (props) => {

    // Reading environment variable start
    const { testimonialLoading, testimonials, testimonialError } = useTestimonialContext();

    // Constant variable
    const classes = `eduvibe-testimonial-four edu-testimonial-activation testimonial-item-3 mt--40 edu-slick-button ${props.className ? props.className : ''}`;

    if (testimonialLoading) {
        return (
            <div>
                <Spinner />
            </div>
        )
    }

    const sliderSettings = {
        ...TestimonialFourParams,
        infinite: testimonials.length > 1, // Only infinite if more than 1
        arrows: testimonials.length > 1,
        dots: testimonials.length > 1,
    };

    return (
        <div className='text-center'>
            {Boolean(testimonialError && !testimonialLoading) &&
                <ErrorComponent errorCode="500" />
            }
            {Boolean(!testimonialLoading && !testimonialError && ((testimonials && !testimonials.length) || !testimonials)) &&
                < ErrorComponent errorCode="404" mainError="Ooops..! No Testimonial Data availble. Please get Back later." />
            }
            <Slider
                className={classes}
                {...sliderSettings}
                sett
            >

                {Boolean(!testimonialLoading && !testimonialError && testimonials && testimonials.length) &&
                    testimonials.map((item, i) => (
                        <div className="testimonial-card-box" key={i}>
                            <div className="inner">
                                <div className="client-info">
                                    <div className="thumbnail">
                                        {/* <img src={`${process.env.PUBLIC_URL}/images/testimonial/testimonial-04/${item.image}`} alt="Client Thumb" onError={onImageError} /> */}
                                        <Avatar size='45' maxInitials={1} color={_setBgColor(item.name || "Guest User")} name={item.name || "Guest User"} textSizeRatio={2.25} round />
                                    </div>
                                    <div className="content">
                                        <ToolTip title={item?.name} placement="top" id={i}>
                                            <h6 className="title text-start">{truncateText(item?.name, 20)}</h6>
                                        </ToolTip>
                                        <ToolTip title={item?.designation} placement="top" id={i}>
                                            <span className="designation text-start">{truncateText(item?.designation, 20)}</span>
                                        </ToolTip>

                                    </div>
                                </div>
                                <p className="description">“ {item.details} ”</p>
                                <div className="rating eduvibe-course-rating-stars">
                                    {[...Array(5)].map((_, index) => {
                                        return <i key={index} className={index < item.rating ? 'on icon-Star' : 'off icon-Star'}></i>
                                    })}
                                </div>
                            </div>
                        </div>
                    ))}
            </Slider>
        </div>
    )
}

export default TestimonialFour;